import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import WithOutSilderEvent from "../../components/WithOutSilderEvent";

const EventPage = () =>
{
  return (
    <Fragment>
      <PageTitle pageTitle={ "Event" } pagesub={ "Event" } />
      <WithOutSilderEvent evCLass={ "section-padding" } />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default EventPage;
